export const SET_CURRENT_APPEAL_META = "SET_CURRENT_APPEAL_META";

export default {
  SET_CURRENT_APPEAL_META
};
